<div class="reset-component-wrapper">
  <div
    class="container-fluid px-5 py-5 d-flex align-items-center justify-content-center"
  >
    <div class="card mb-0">
      <div
        class="card-body p-3 d-flex align-items-center justify-content-center"
      >
        <div
          class="reset-form-wrapper d-flex align-items-center justify-content-center"
        >
          <div>
            <img
              src="../../../../assets/images/login/aegislogo.png"
              alt=""
              width="200"
            />
          </div>
          <span *ngIf="!passSuccess" class="title-heading"
            >Reset your password</span
          >
          <span *ngIf="passSuccess" class="title-heading me-4 pe-2"
            >Password changed</span
          >
          <span
            *ngIf="!passSuccess"
            class="text-light-gray text-wrap d-flex sub-heading"
            >Enter a new password for&nbsp;({{
              userEmail ? userEmail : "Email Address"
            }})</span
          >
          <span
            *ngIf="passSuccess"
            class="text-light-gray me-2 d-flex sub-heading"
            ><a class="text-decoration-underline" routerLink="/auth/login"
              >Sign in</a
            >&nbsp;with your new password.</span
          >
          <div class="col-lg-8" [ngClass]="{ invisible: passSuccess }">
            <div class="form-group">
              <form action="" [formGroup]="passwordForm">
                <div class="mb-5">
                  <label class="mx-2 my-1" for="">New Password</label>
                  <div class="password-showhide-control">
                    <input
                      [type]="hidePassword1 ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Enter Password"
                      formControlName="password"
                      [(ngModel)]="ResetPasswordRequestmodel.newPassword"
                      (ngModelChange)="validatePassword('password', $event)"
                    />
                    <button
                      type="button"
                      (click)="hidePassword1 = !hidePassword1"
                      class="btn-showHide"
                    >
                      {{ hidePassword1 ? "Hide" : "Show" }}
                    </button>
                  </div>
                  <div *ngIf="passwordErrors">
                    <span
                      class="text-danger text-sm text-start mt-1 line-h-1"
                      >{{ passwordErrors }}</span
                    >
                  </div>
                </div>
                <div class="mb-4">
                  <label class="mx-2 my-1" for="">Confirm Password</label>
                  <div class="password-showhide-control">
                    <input
                      [type]="hidePassword2 ? 'text' : 'password'"
                      type="password"
                      class="form-control"
                      placeholder="Enter Password"
                      formControlName="confirmPassword"
                      [(ngModel)]="ResetPasswordRequestmodel.confirmNewPassword"
                      (ngModelChange)="
                        validatePassword('confirmPassword', $event)
                      "
                    />
                    <button
                      type="button"
                      (click)="hidePassword2 = !hidePassword2"
                      class="btn-showHide"
                    >
                      {{ hidePassword2 ? "Hide" : "Show" }}
                    </button>
                  </div>
                  <div *ngIf="confirmPasswordErrors" class="">
                    <span
                      class="text-danger text-sm text-start mt-1 line-h-1"
                      >{{ confirmPasswordErrors }}</span
                    >
                  </div>
                  <span
                    class="text-danger"
                    *ngIf="
                      !confirmPasswordErrors &&
                      confirmPassword.errors?.match &&
                      submitted
                    "
                  >
                    New Password and confirmation password do not match</span
                  >
                </div>
                <div class="d-flex justify-content-between mt-5">
                  <app-button
                    [buttonLable]="enumButtonName.CONFIRM"
                    [buttonClass]="'border-blue px-2 font-15'"
                    [buttonType]="'submit'"
                    (click)="resetPassword()"
                  >
                  </app-button>
                  <app-button
                    [buttonLable]="enumButtonName.CANCEL"
                    routerLink="/auth/login"
                    [buttonClass]="'border-grey px-2 font-15'"
                  >
                  </app-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
